/**
 * Where a tour step's target sits on screen, or null when the person cannot
 * see it: absent, unsized, off-screen (a collapsed sidebar stays mounted
 * outside the viewport) or inert (New chat under an open Recents filter).
 * Null centres the step's card.
 *
 * @module components/onboarding/tourTarget
 */
export interface TourRect {
  readonly top: number;
  readonly left: number;
  readonly width: number;
  readonly height: number;
}

export function measureTourTarget(selector: string): TourRect | null {
  const element = document.querySelector<HTMLElement>(selector);
  if (!element || element.closest("[inert]")) return null;
  const rect = element.getBoundingClientRect();
  if (rect.width === 0 && rect.height === 0) return null;
  const onScreen =
    rect.right > 0 && rect.bottom > 0 && rect.left < window.innerWidth && rect.top < window.innerHeight;
  return onScreen ? { top: rect.top, left: rect.left, width: rect.width, height: rect.height } : null;
}
